import { connect } from 'react-redux';
import { exposActions } from '../../../../../redux/admin/expos/actions';
import UnpublishExpoModal from './index';

const mapDispatchToProps = {
  unpublishExpo: exposActions.unpublishExpo,
};

export default connect(null, mapDispatchToProps)(UnpublishExpoModal);
